import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { HttpHelper } from 'app/shared/common/utils/http/HttpHelper';
import { NotificationConstant } from './notification.constant';
import { IMarkAsRead } from './notification.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    unreadCount: number = 0;
    isReloadData: boolean = false;
    notifications: Notification[];
    public _isTriggerAPIPagingListNotification: BehaviorSubject<boolean> = new BehaviorSubject(null);
    public _triggerCountNotificationUnread: BehaviorSubject<boolean> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _httpHelper: HttpHelper) {
    }

    async getPagingList(keyword, offsetCurrent): Promise<any> {
        // const loadCfg = {
        //     startRow: 0,
        //     numOfRow: offsetCurrent,
        //     filters: [
        //         {
        //             field: "keyword",
        //             value: keyword,
        //             comparison: "eq",
        //             type: "string"
        //         }
        //     ],
        //     sortField: "",
        //     sortDir: "DESC"
        // };
        const loadCfg = {
            "startRow": 0,
            "endRow": offsetCurrent,
            "rowGroupCols": [],
            "valueCols": [],
            "pivotCols": [],
            "pivotMode": false,
            "groupKeys": [],
            "filterModel": {},
            "sortModel": []
        }
        if (keyword) {
            loadCfg["filterModel"] = {
                "ftsValue": {
                    "type": "contains",
                    "filterType": "text",
                    "filter": keyword
                }
            }
        }
        return this._httpHelper.methodPostService(NotificationConstant.GET_PAGING_LIST, loadCfg);
    }

    async getCountUnreadNotification(): Promise<any> {
        return this._httpHelper.methodGetService(NotificationConstant.GET_COUNT_UNREAD);
    }

    async markAsReadService(data: IMarkAsRead): Promise<any> {
        return this._httpHelper.methodPostService(NotificationConstant.MARK_READ, data);
    }

    async markAsAllReadService(): Promise<any> {
        return this._httpHelper.methodPostService(NotificationConstant.READ_ALL, null);
    }

    triggerAPIPagingOnHome(status: boolean) {
        this._isTriggerAPIPagingListNotification.next(status);
    }
}
